<template>
  <el-dialog v-model="dialogVisible"  width="50%" center :max-width="'350px'">
    <div class="form-container">
      <!-- 右侧表单 -->
      <div class="form-wrapper">
        <!-- 切换按钮 -->
        <div class="tab">
          <span class="active">登录</span>
        </div>

        <!-- 根据 isLogin 状态显示不同内容 -->
        <!-- 登入表单 -->
        <el-form
          label-position="top"
          :model="loginForm"
          :rules="loginRules"
          ref="loginFormRef"
          label-width="80px"
        >
          <el-form-item label="手机号">
            <el-input v-model="loginForm.phone" placeholder="请输入手机号" />
          </el-form-item>
          <el-form-item label="验证码">
            <div style="display: flex; align-items: center; gap: 10px;">
              <el-input v-model="loginForm.code" placeholder="请输入验证码" style="flex: 1;" />
              <el-button 
                type="primary" 
                :disabled="countdown > 0"
                @click="sendSmsCode"
                style="white-space: nowrap; min-width: 120px;"
              >
                {{ countdown > 0 ? `${countdown}秒后重发` : '获取验证码' }}
              </el-button>
            </div>
          </el-form-item>
          
          <!-- 隐私政策同意 -->
          <el-form-item>
            <label class="privacy-checkbox">
              <input 
                type="checkbox" 
                v-model="agreePrivacy" 
                id="agree-privacy"
              />
              <span class="checkmark"></span>
              <span class="privacy-text">
                我已阅读并同意
                <a href="#/privacy-policy" class="privacy-link" target="_blank">
                  《军招助手隐私政策》
                </a>
              </span>
            </label>
          </el-form-item>
          
          <el-button type="primary" @click="submitLogin" style="width: 100%"
            >登录</el-button
          >
        </el-form>
      </div>
    </div>
    <!-- 滑块验证模态框 -->
    <el-dialog v-model="sliderVisible" title="安全验证" width="50%" center :max-width="'350px'">
      <div class="slider-container">
        <p>请完成滑块验证后获取验证码</p>
        <div class="puzzle-container">
          <div class="puzzle-image" ref="puzzleImage">
            <div 
              class="puzzle-target"
              :style="{ left: targetPosition + '%' }"
            ></div>
            <div 
              class="puzzle-piece"
              ref="puzzlePiece"
              :style="{ left: sliderPosition + '%' }"
            ></div>
          </div>
          <div class="slider-wrapper">
            <div 
              class="slider-track"
              ref="sliderTrack"
              @mousedown="startSlider"
              @touchstart="startSlider"
            >
              <div 
                class="slider-handle"
                ref="sliderHandle"
                :style="{ left: sliderPosition + '%' }"
              >
                <i class="el-icon-d-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { login } from "@/api/loginApi";
import { getCaptcha } from "@/api/loginApi";
import { ElMessage } from "element-plus";
import { registerUser } from "@/api/loginApi";
import { useRouter } from "vue-router"; // 引入 useRouter
import { useAuthStore } from "@/store/authStore"; // 替换 useUserStore
import service from "@/api/axiosConfig";

// 获取 store 实例
const authStore = useAuthStore(); // 替换 userStore
//页面跳转初始化
const router = useRouter();
// 弹窗状态
const dialogVisible = ref(false);
const isLogin = ref(true); // 控制显示登录或注册表单
// 登录表单引用
const loginFormRef = ref(null);
// 注册表单引用
const registerFormRef = ref(null);

// 倒计时状态
const countdown = ref(0);

// 滑块验证状态
const sliderValidated = ref(false);
const sliderVisible = ref(false);

// 隐私政策相关
const agreePrivacy = ref(false);
const sliderPosition = ref(0);
const isDragging = ref(false);
const targetPosition = ref(0); // 目标位置（随机生成）

//登入表单数据
const loginForm = ref({
  phone: "",
  code: "",
});
//注册表单数据
const registerForm = ref({
  username: "",
  password: "",
  confirmPassword: "",
  code: "",
});
//存储验证码图片
const captchaImg = ref("");

// 发送短信验证码
const sendSmsCode = async () => {
  if (!loginForm.value.phone) {
    ElMessage.error("请输入手机号");
    return;
  }
  
  // 手机号格式验证
  const phoneRegex = /^1[3-9]\d{9}$/;
  if (!phoneRegex.test(loginForm.value.phone)) {
    ElMessage.error("手机号格式不正确");
    return;
  }
  
  // 生成随机目标位置
  generateTargetPosition();
  
  // 显示滑块验证
  sliderVisible.value = true;
};

// 生成随机目标位置
const generateTargetPosition = () => {
  // 生成20-80之间的随机位置
  targetPosition.value = Math.floor(Math.random() * 60) + 20;
  console.log('生成的目标位置:', targetPosition.value);
};

// 滑块验证成功
const handleSliderSuccess = async () => {
  sliderValidated.value = true;
  sliderVisible.value = false;
  
  try {
    console.log('发送验证码请求数据:', { phone: loginForm.value.phone });
    const res = await service.post("/interface/sms/sendCode", {
      phone: loginForm.value.phone
    });
    
    console.log('发送验证码响应:', res);
    
    if (res.data.code === 200) {
      ElMessage.success("验证码发送成功");
      // 开始倒计时
      startCountdown();
    } else {
      ElMessage.error(res.data.msg || "验证码发送失败");
    }
  } catch (error) {
    console.error("发送验证码失败:", error);
    ElMessage.error("验证码发送失败，请重试");
  }
};

// 滑块验证失败
const handleSliderError = () => {
  sliderValidated.value = false;
  ElMessage.error("验证失败，请重试");
};

// 开始滑块拖动
const startSlider = (e) => {
  isDragging.value = true;
  document.addEventListener('mousemove', onSliderMove);
  document.addEventListener('mouseup', stopSlider);
  document.addEventListener('touchmove', onTouchMove);
  document.addEventListener('touchend', stopTouch);
  
  // 处理鼠标事件
  if (e.clientX) {
    onSliderMove(e);
  }
  // 处理触摸事件
  else if (e.touches && e.touches[0]) {
    onTouchMove(e);
  }
};

// 滑块拖动中（鼠标）
const onSliderMove = (e) => {
  if (!isDragging.value) return;
  
  const sliderTrack = document.querySelector('.slider-track');
  if (!sliderTrack) return;
  
  const rect = sliderTrack.getBoundingClientRect();
  const offsetX = e.clientX - rect.left;
  updateSliderPosition(offsetX, rect.width);
};

// 滑块拖动中（触摸）
const onTouchMove = (e) => {
  if (!isDragging.value) return;
  
  const sliderTrack = document.querySelector('.slider-track');
  if (!sliderTrack) return;
  
  const rect = sliderTrack.getBoundingClientRect();
  const offsetX = e.touches[0].clientX - rect.left;
  updateSliderPosition(offsetX, rect.width);
};

// 更新滑块位置
const updateSliderPosition = (offsetX, trackWidth) => {
  let position = (offsetX / trackWidth) * 100;
  
  // 限制范围
  position = Math.max(0, Math.min(100, position));
  sliderPosition.value = position;
  
  // 更新拼图块的背景位置
  const puzzlePiece = document.querySelector('.puzzle-piece');
  if (puzzlePiece) {
    // 计算背景位置偏移
    const puzzleImage = document.querySelector('.puzzle-image');
    if (puzzleImage) {
      const imageRect = puzzleImage.getBoundingClientRect();
      const pieceWidth = 60;
      const maxOffset = imageRect.width - pieceWidth;
      const backgroundOffset = (position / 100) * maxOffset;
      puzzlePiece.style.backgroundPosition = `-${backgroundOffset}px 0`;
    }
  }
};

// 结束滑块拖动（鼠标）
const stopSlider = () => {
  isDragging.value = false;
  document.removeEventListener('mousemove', onSliderMove);
  document.removeEventListener('mouseup', stopSlider);
  document.removeEventListener('touchmove', onTouchMove);
  document.removeEventListener('touchend', stopTouch);
  validateSlider();
};

// 结束滑块拖动（触摸）
const stopTouch = () => {
  stopSlider();
};

// 验证滑块位置
const validateSlider = () => {
  // 验证是否成功（拖动到目标位置附近，容差为5%）
  if (Math.abs(sliderPosition.value - targetPosition.value) <= 5) {
    // 验证成功
    handleSliderSuccess();
  } else {
    // 验证失败，重置滑块
    sliderPosition.value = 0;
    handleSliderError();
  }
};

// 开始倒计时
const startCountdown = () => {
  countdown.value = 60;
  const timer = setInterval(() => {
    if (countdown.value > 0) {
      countdown.value--;
    } else {
      clearInterval(timer);
    }
  }, 1000);
};

//模拟获取验证码
const fetchCaptcha = async () => {
  console.log("正在从接口获取验证码...");

  try {
    const res = await getCaptcha();

    if (res.data.code === 200) {
      loginForm.value.uuid = res.uuid || res.data?.uuid;
      captchaImg.value = res.img || res.data?.img;
    } else {
      ElMessage.error("验证码获取失败");
      captchaImg.value = "";
    }
  } catch (error) {
    console.error("获取验证码异常:", error);
    ElMessage.error("验证码获取失败，请重试");
    captchaImg.value = "";
  }
};
// 页面加载或弹窗打开时自动获取验证码
onMounted(() => {
  // 不再自动获取图片验证码，改为短信验证码
});
//登入表单验证规则
const loginRules = {
  phone: [
    { required: true, message: "请输入手机号", trigger: "blur" },
    { pattern: /^1[3-9]\d{9}$/, message: "手机号格式不正确", trigger: "blur" },
  ],
  code: [
    { required: true, message: "请输入验证码", trigger: "blur" },
    { len: 6, message: "请输入6位验证码", trigger: "blur" },
  ],
};
//注册表单验证规则
const registerRules = {
  username: [
    { required: true, message: "请输入用户名", trigger: "blur" },
    { min: 3, max: 15, message: "用户名长度在3到15个字符", trigger: "blur" },
  ],
  password: [
    { required: true, message: "请输入密码", trigger: "blur" },
    { min: 6, message: "密码不能少于6位", trigger: "blur" },
  ],
  confirmPassword: [
    { required: true, message: "请再次输入密码", trigger: "blur" },
    {
      validator: (rule, value, callback) => {
        if (value !== registerForm.value.password) {
          callback(new Error("两次输入密码不一致"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
  code: [
    { required: true, message: "请输入验证码", trigger: "blur" },
    { len: 4, message: "请输入4位验证码", trigger: "blur" },
  ],
};
//登入提交逻辑
const submitLogin = () => {
  // 检查是否同意隐私政策
  if (!agreePrivacy.value) {
    ElMessage.error("请先阅读并同意隐私政策");
    return;
  }
  
  loginFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        const res = await login(loginForm.value);
        // console.log("登录响应数据:", res.data); // 打印整个响应数据

        if (res.data.code === 200) {
          const token = res.data.accessToken;
          // console.log("登录返回的 token:", token); // 确认 token 非空且格式正确

          if (!token || typeof token !== "string") {
            ElMessage.error("无效的 token");
            return;
          }
          // console.log("准备设置 token 到 store:", token); // ✅ 新增日志
          authStore.setToken(token);
          authStore.setUser({ phone: loginForm.value.phone });

          ElMessage.success("登录成功！");
          dialogVisible.value = false;
        } else {
          ElMessage.error(res.data.msg || "登录失败");
        }
      } catch (error) {
        ElMessage.error("登录失败，请检查网络或账号信息");
      }
    } else {
      return false;
    }
  });
};
//注册提交逻辑
const submitRegister = () => {
  registerFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        const res = await registerUser(registerForm.value);

        // console.log("注册响应:", res.data);

        if (res.data.code === 200) {
          ElMessage.success("注册成功！");
          // localStorage.setItem("token", res.data.token); // 假设返回 token
          dialogVisible.value = false;
          // 可选：跳转路由
          // router.push('/usercenter');
        } else {
          ElMessage.error(res.data.msg || "注册失败");
          // fetchCaptcha(); // 刷新验证码
        }
      } catch (error) {
        // console.error("注册请求失败:", error);
        ElMessage.error("注册失败，请检查网络或重试");
        // fetchCaptcha(); // 刷新验证码
      }
    } else {
      // console.log("注册验证失败");
      return false;
    }
  });
};
// 定义打开弹窗的方法
const openDialog = () => {
  // 清空表单数据
  loginForm.value = {
    phone: "",
    code: ""
  };
  // 重置倒计时
  countdown.value = 0;
  // 重置滑块验证状态
  sliderValidated.value = false;
  sliderPosition.value = 0;
  // 打开弹窗
  dialogVisible.value = true;
  // 打开时不再刷新图片验证码，改为短信验证码
};

// 暴露方法给父组件调用
defineExpose({ openDialog });
</script>

<style scoped>
.form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 20px;
}

.form-wrapper {
  width: 100%;
  max-width: 400px;
}

.tab {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  position: relative;
}

.tab span {
  cursor: pointer;
  font-weight: 600;
  color: #666;
  font-size: 18px;
  padding: 0 20px;
  position: relative;
  transition: all 0.3s;
}

.tab .active {
  color: #409eff;
}

.tab .active::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 20px;
  right: 20px;
  height: 2px;
  background: #409eff;
  border-radius: 1px;
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    width: 0;
    left: 50%;
  }
  to {
    width: calc(100% - 40px);
    left: 20px;
  }
}

.el-form-item {
  margin-bottom: 25px;
}

.el-form-item__label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.el-input {
  width: 100%;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  transition: all 0.3s;
  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
}

.el-input:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.el-button {
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.3s;
  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
  min-width: 44px;
}

.el-button--primary {
  background: linear-gradient(135deg, #409eff, #69b1ff);
  border: none;
}

.el-button--primary:hover {
  background: linear-gradient(135deg, #3a8ee6, #53a8ff);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.el-button--primary:active {
  transform: translateY(0);
}

.el-button:disabled {
  background: #f5f7fa;
  color: #c0c4cc;
  border: 1px solid #e4e7ed;
}

/* 隐私政策复选框 */
.privacy-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
}

.privacy-checkbox input[type="checkbox"] {
  display: none;
}

.checkmark {
  width: 18px;
  height: 18px;
  border: 2px solid #dcdfe6;
  border-radius: 4px;
  margin-right: 10px;
  position: relative;
  transition: all 0.3s;
}

.privacy-checkbox input[type="checkbox"]:checked + .checkmark {
  background-color: #409eff;
  border-color: #409eff;
}

.privacy-checkbox input[type="checkbox"]:checked + .checkmark::after {
  content: '';
  position: absolute;
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.privacy-text {
  flex: 1;
  line-height: 1.5;
}

.privacy-link {
  color: #409eff;
  text-decoration: none;
}

.privacy-link:hover {
  text-decoration: underline;
}

/* 滑块验证样式 */
.slider-container {
  padding: 20px 15px;
}

.slider-container p {
  text-align: center;
  color: #606266;
  margin-bottom: 20px;
  font-size: 14px;
}

.puzzle-container {
  margin-top: 15px;
}

.puzzle-image {
  width: 100%;
  height: 180px;
  background: url('https://picsum.photos/400/200') center/cover no-repeat;
  border-radius: 12px;
  position: relative;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  overflow: hidden;
}

.puzzle-image::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(64, 158, 255, 0.1), rgba(64, 158, 255, 0.05));
  z-index: 1;
}

.puzzle-target {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  border: 2px dashed #fff;
  border-radius: 6px;
  background: rgba(255,255,255,0.3);
  box-shadow: inset 0 0 15px rgba(0,0,0,0.2);
  z-index: 2;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    box-shadow: inset 0 0 15px rgba(0,0,0,0.2);
  }
  50% {
    box-shadow: inset 0 0 25px rgba(0,0,0,0.3);
  }
}

.puzzle-piece {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  background: url('https://picsum.photos/400/200') center/cover no-repeat;
  background-position: 0 0;
  border: 2px solid #fff;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  transition: all 0.2s;
  z-index: 3;
}

.slider-wrapper {
  margin-top: 20px;
}

.slider-track {
  width: 100%;
  height: 40px;
  background: #f0f2f5;
  border-radius: 20px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  box-shadow: inset 0 1px 3px rgba(0,0,0,0.1);
}

.slider-handle {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 36px;
  height: 36px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  cursor: pointer;
  transition: all 0.3s;
  z-index: 10;
}

.slider-handle:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  transform: scale(1.05);
}

.slider-handle:active {
  transform: scale(0.95);
}

.slider-track::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(90deg, #409eff, #69b1ff);
  border-radius: 20px;
  transition: width 0.2s ease;
  width: v-bind('sliderPosition + "%"');
  z-index: 1;
}

/* 弹窗样式 */
.el-dialog {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
}

.el-dialog__header {
  background: #f8f9fa;
  padding: 20px;
  border-bottom: 1px solid #e4e7ed;
}

.el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.el-dialog__body {
  padding: 30px 20px;
}

.el-dialog__footer {
  padding: 20px;
  border-top: 1px solid #e4e7ed;
  background: #f8f9fa;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .form-container {
    padding: 15px;
  }
  
  .el-form-item {
    margin-bottom: 20px;
  }
  
  .el-input,
  .el-button {
    height: 44px;
  }
  
  .puzzle-image {
    height: 160px;
  }
  
  .puzzle-target,
  .puzzle-piece {
    width: 50px;
    height: 50px;
  }
  
  .slider-container {
    padding: 15px 10px;
  }
  
  .slider-container p {
    margin-bottom: 15px;
  }
  
  .puzzle-container {
    margin-top: 10px;
  }
  
  .puzzle-image {
    margin-bottom: 15px;
  }
}

@media (max-width: 480px) {
  .form-container {
    padding: 10px;
  }
  
  .el-form-item {
    margin-bottom: 15px;
  }
  
  .el-input,
  .el-button {
    height: 42px;
  }
  
  .puzzle-image {
    height: 140px;
  }
  
  .puzzle-target,
  .puzzle-piece {
    width: 45px;
    height: 45px;
  }
  
  .slider-container {
    padding: 10px;
  }
  
  .slider-container p {
    margin-bottom: 10px;
    font-size: 13px;
  }
  
  .puzzle-container {
    margin-top: 5px;
  }
  
  .puzzle-image {
    margin-bottom: 10px;
  }
  
  .slider-track {
    height: 36px;
  }
  
  .slider-handle {
    width: 32px;
    height: 32px;
  }
}
</style>
